<span [ngClass]="{ 'pl-3 border-l-0 md:border-l-2 border-th-primary border-opacity-25': !!providerGroup?.groupingKey }"
  class="flex flex-col m-3">
  @for (service of providerGroup?.services; track service; let last = $last) {
    <div
      [ngClass]="{ 'pb-6': !last }">
      <provider-group-service-header [service]="service"></provider-group-service-header>
      <ul class="print:list-unstyled">
        @for (service of service?.totals; track service; let i = $index) {
          <li>
            @if (service.value) {
              <provider-group-service
              [service]="service"></provider-group-service>
            }
          </li>
        }
      </ul>
    </div>
  }
</span>
